import React from 'react';
import { Box, Drawer, Toolbar } from '@mui/material';

import AnnotationTools from './AnnotationTools/AnnotationTools';
import DocumentTools from './DocumentTools/DocumentTools';
import SealingTools from './SealingTools/SealingTools';

export default function LeftSidebar() {
  return (
    <Drawer
      variant="permanent"
      sx={{
        '& .MuiDrawer-paper': {
          position: 'relative',
          width: 400,
          overflowX: 'hidden',
          overflowY: 'hidden',
          '&:hover': {
            overflowY: 'auto',
          },
          '&::-webkit-scrollbar': {
            display: 'none',
          },
          scrollbarWidth: 'none',
        },
      }}
    >
      <Box sx={{ width: 400 }}>
        <Toolbar />
        <DocumentTools />
        <SealingTools />
        <AnnotationTools />
      </Box>
    </Drawer>
  );
}
